import { Vector3 } from '@babylonjs/core';
import { EnemyDistributionConfig } from '../EnemyGenerator';
import { ENEMY_ANIMATIONS, EnemyBehavior } from './EnemyBehavior';

/**
 * Chase behavior - sprint after player when in range, walk back otherwise
 */

export class EnemyChaseBehavior extends EnemyBehavior {
  private isChasing: boolean = false;

  constructor(startPosition: Vector3, config: EnemyDistributionConfig) {
    super('enemyChase', startPosition, config);
  }

  behaviorUpdate(deltaTime: number): void {
    const playerDistance = this.getPlayerDistance();

    if (playerDistance <= this.config.detectionRange) {
      // Chase player - use sprint animation
      this.isChasing = true;
      this.playAnimation(ENEMY_ANIMATIONS.SPRINT, true, 1.5);

      const playerPos = this.getPlayerPosition();
      this.moveToward(playerPos, deltaTime * 1.5); // Faster while chasing
    } else if (this.isChasing) {
      // Return to start position - use walk animation
      const distToStart = Vector3.Distance(this.mesh.position, this.startPosition);

      if (distToStart > 0.5) {
        this.playAnimation(ENEMY_ANIMATIONS.WALK, true);
        this.moveToward(this.startPosition, deltaTime);
      } else {
        this.mesh.position.copyFrom(this.startPosition);
        this.snapToGround(deltaTime);
        this.isChasing = false;
        this.playAnimation(ENEMY_ANIMATIONS.IDLE, true);
      }
    } else {
      // Idle at start
      this.playAnimation(ENEMY_ANIMATIONS.IDLE, true);
      this.snapToGround(deltaTime);
    }
  }

  clone(): EnemyChaseBehavior {
    return new EnemyChaseBehavior(this.startPosition, this.config);
  }
}
